import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function MorosityPercentage({ morosityPercentage }) {
  return (
    <Col className="morosity-percentage">
      <h4 className="text-center mb-4">% Morosidad al momento</h4>
      {morosityPercentage !== undefined ? (
        <>
          <Row>
            <Col className="morosity-value">
              <h2>{morosityPercentage.toFixed(0)}%</h2>
            </Col>
          </Row>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </Col>
  );
}

export default MorosityPercentage;
